// extracted by mini-css-extract-plugin
export default {"postColumn":"GearView__postColumn__B7U9Z"};